export const LIMIT = 10;
export const UPLOAD_CONST = "";
export const URI = "https://api.fairleadertechnologies.com";
export const ROLES = [
  { label: "SUPER_ADMIN", value: "SUPER_ADMIN" },
  { label: "AGENT", value: "AGENT" },
];
